export interface GameSettings {
  // Mouse Wheel Panning (Controls)
  mouseWheelPanSpeed: number; // Pixels per wheel tick (vertical)
  mouseWheelPanSpeedX: number; // Pixels per wheel tick (horizontal)
  mouseWheelPanInverted: boolean; // If true, scroll up pans down
  mouseWheelPanInvertedX: boolean; // If true, scroll right pans left
  mouseWheelPanMinY: number; // Minimum Y position (negative = pan up limit)
  mouseWheelPanMaxY: number; // Maximum Y position (positive = pan down limit)
  mouseWheelPanMinX: number; // Minimum X position (negative = pan left limit)
  mouseWheelPanMaxX: number; // Maximum X position (positive = pan right limit)
  mouseWheelPanEnabled: boolean; // Enable/disable mouse wheel panning
  
  // Graphics (Placeholder)
  // Future: particle effects, visual quality, grid visibility
  
  // Audio
  masterVolume: number; // 0.0 to 1.0 (0% to 100%)
  musicVolume: number; // 0.0 to 1.0 (0% to 100%)
  sfxVolume: number; // 0.0 to 1.0 (0% to 100%)
  
  // Gameplay
  quickSellEnabled: boolean;
  quickBuildEnabled: boolean;
  showInstructionsOnStart: boolean;
  
  // Language
  language: 'en' | 'pt-BR' | 'fr' | 'it' | 'de' | 'zh' | 'ru';
}

export const DEFAULT_SETTINGS: GameSettings = {
  // Mouse Wheel Panning (Controls)
  mouseWheelPanSpeed: 50,
  mouseWheelPanSpeedX: 50,
  mouseWheelPanInverted: false,
  mouseWheelPanInvertedX: false,
  mouseWheelPanMinY: -500, // Allow panning up 500 pixels
  mouseWheelPanMaxY: 500, // Allow panning down 500 pixels
  mouseWheelPanMinX: -500, // Allow panning left 500 pixels
  mouseWheelPanMaxX: 500, // Allow panning right 500 pixels
  mouseWheelPanEnabled: false, // Disabled by default
  
  // Graphics (Placeholder - no settings yet)
  
  // Audio (default 50%)
  masterVolume: 0.5,
  musicVolume: 0.5,
  sfxVolume: 0.5,
  
  // Gameplay defaults
  quickSellEnabled: true,
  quickBuildEnabled: true,
  showInstructionsOnStart: true,
  
  // Language default
  language: 'en',
};

export function loadSettings(): GameSettings {
  const stored = localStorage.getItem('mazingHuntersSettings');
  if (stored) {
    try {
      const parsed = JSON.parse(stored);
      return { ...DEFAULT_SETTINGS, ...parsed };
    } catch (e) {
      console.error('Failed to parse settings:', e);
    }
  }
  return { ...DEFAULT_SETTINGS };
}

export function saveSettings(settings: GameSettings): void {
  localStorage.setItem('mazingHuntersSettings', JSON.stringify(settings));
}

